import React from "react"
import Navigation from './Navigation';

function Header() {
  return (
    <header>
      <p className='poppins-700'>regards</p>
      <Navigation />
    </header>
  )
}

export default Header